// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Components
import StatusTrackerError from './StatusTrackerError';

// Selectors
import { getStatusTrackerData } from 'store/reducers/statusTracker/selectors';

const mapStateToProps = state => ({
  statusTrackerData: getStatusTrackerData(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(StatusTrackerError);



// WEBPACK FOOTER //
// ./src/components/pages/StatusTrackerError/StatusTrackerErrorContainer.js